import React, { useState } from 'react'
import { FormControl } from 'react-bootstrap'
import { FaSearch } from 'react-icons/fa'
import { GrClose } from 'react-icons/gr'
import { ATSearchBoxProps } from './FormComponentProps'
import './FormComponent.css'
const ATSearchBox = (props: ATSearchBoxProps) => {
  const {
    name,
    searchInput,
    placeholder,
    disabled,
    handleChange,
    onBlurHandler,
  } = props
  const [hasFocus, setHasFocus] = useState(false)

  const onFocusChange = () => {
    setHasFocus(true)
  }

  const onCloseButton = (e: React.SyntheticEvent) => {
    const target = e.target as HTMLInputElement
    target.value = ''
    handleChange(e)
    setHasFocus(false)
  }
  const onHandleBlur = (e: React.SyntheticEvent) => {
    onBlurHandler(e)
  }

  return (
    <div
      className={`searchInput ${disabled ? 'disabled' : ''} ${
        props.className || ''
      }`}
    >
      <div className="search input-group">
        <FormControl
          type="text"
          name={name}
          onChange={handleChange}
          title="search"
          value={searchInput}
          onFocus={onFocusChange}
          onBlur={onHandleBlur}
          placeholder={placeholder}
          aria-label="search box"
          autoComplete="off"
        />
        {hasFocus ? (
          <GrClose size={16} onClick={onCloseButton} />
        ) : (
          <FaSearch size={16} />
        )}
      </div>
    </div>
  )
}
export default ATSearchBox
